export default {
  all: {
    isLoading: false,
    error: '',
    data: [],
  },
  list: {
    isLoading: false,
    error: '',
    paginationOptions: {
      page: 1,
      size: 50,
      name__icontains: '',
      ordering: '-created_at',
    },
    data: {
      items: [],
      count: 0,
    },
  },
  add: {
    isLoading: false,
    error: '',
  },
  show: {
    isLoading: false,
    error: '',
    data: {},
  },
  update: {
    isLoading: false,
    error: '',
  },
  delete: {
    isLoading: false,
    error: '',
  },
  partialImport: {
    isLoading: false,
    error: '',
    importedResources: null,
  },
  partialExport: {
    isLoading: false,
    error: '',
  },
};
